const NotAvailable = () => {
  return (
    <div className='min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-black flex items-center justify-center px-6 text-center'>
      <div className='max-w-md space-y-6'>
        <h1 className='text-4xl md:text-5xl font-extrabold text-white'>
          🚧 Under Development
        </h1>
        <p className='text-gray-400 text-lg md:text-xl leading-relaxed'>
          This page is currently being built
          <br />
          Stay tuned for something awesome!
        </p>
        <div className='pt-4'>
          <a
            href='mailto:mursalinhossain377@gmail.com'
            className='inline-block px-6 py-3 rounded-2xl bg-gradient-to-r from-purple-600 to-indigo-500 hover:from-purple-500 hover:to-indigo-400 transition-all text-white font-medium shadow-lg hover:shadow-purple-500/30'
          >
            📧 Contact Me
          </a>
        </div>
        <footer className='text-sm text-gray-600 pt-8'>
          © {new Date().getFullYear()} Mursalin Hossain. All rights reserved.
        </footer>
      </div>
    </div>
  );
};

export default NotAvailable;
